import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lang } from '../utils/translations';
import './LegalPages.css';

export default function TermsPage() {
  const [lang, setLang] = useState<Lang>(() => (localStorage.getItem('cartz_lang') as Lang) || 'en');
  const isRTL = lang === 'ar';

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    setLang(newLang);
    localStorage.setItem('cartz_lang', newLang);
  };

  return (
    <div className="legal-page" dir={isRTL ? 'rtl' : 'ltr'}>
      <nav className="legal-nav">
        <div className="legal-nav-inner">
          <Link to="/" className="landing-logo">
            <img className="cartz-mark" src="/favicon.svg" alt="" />
            <span className="logo-text">Cartz</span>
          </Link>
          <button className="sf-lang-toggle" onClick={toggleLang}>
            {lang === 'en' ? 'عربي' : 'English'}
          </button>
        </div>
      </nav>

      <div className="legal-content">
        {lang === 'ar' ? (
          <>
            <h1>شروط الخدمة</h1>
            <p className="legal-updated">آخر تحديث: 28 مارس 2026</p>

            <h2>1. قبول الشروط</h2>
            <p>باستخدام منصة كارتز ("الخدمة")، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي جزء من هذه الشروط، يرجى عدم استخدام الخدمة.</p>

            <h2>2. وصف الخدمة</h2>
            <p>كارتز هي منصة تجارة إلكترونية تتيح للمستخدمين إنشاء وإدارة متاجرهم الإلكترونية. نوفر استضافة المتجر، معالجة الطلبات، وأدوات إدارة المنتجات.</p>

            <h2>3. حسابات المستخدمين</h2>
            <p>أنت مسؤول عن الحفاظ على سرية معلومات حسابك وكلمة المرور. أنت توافق على قبول المسؤولية عن جميع الأنشطة التي تحدث تحت حسابك.</p>

            <h2>4. محتوى المتجر</h2>
            <p>أنت مسؤول عن جميع المحتوى المنشور في متجرك بما في ذلك المنتجات والأوصاف والصور والأسعار. يجب أن يكون المحتوى قانونياً ولا ينتهك حقوق الآخرين.</p>

            <h2>5. المدفوعات والرسوم</h2>
            <p>قد تنطبق رسوم على بعض خدماتنا. سيتم إعلامك بأي رسوم قبل فرضها. المدفوعات بين المتاجر وعملائها تتم مباشرة ولا تتحمل كارتز مسؤوليتها.</p>

            <h2>6. إنهاء الخدمة</h2>
            <p>يحق لنا تعليق أو إنهاء حسابك في حال انتهاك هذه الشروط أو لأي سبب آخر وفقاً لتقديرنا.</p>

            <h2>7. حدود المسؤولية</h2>
            <p>يتم تقديم الخدمة "كما هي" دون أي ضمانات صريحة أو ضمنية. لا تتحمل كارتز المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناتجة عن استخدام الخدمة.</p>

            <h2>8. التعديلات</h2>
            <p>نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي تغييرات جوهرية.</p>

            <h2>9. التواصل</h2>
            <p>للتواصل معنا بخصوص هذه الشروط، يرجى مراسلتنا على support@cartz.cc</p>
          </>
        ) : (
          <>
            <h1>Terms of Service</h1>
            <p className="legal-updated">Last updated: March 28, 2026</p>

            <h2>1. Acceptance of Terms</h2>
            <p>By using the Cartz platform ("Service"), you agree to be bound by these terms and conditions. If you do not agree to any part of these terms, please do not use the Service.</p>

            <h2>2. Description of Service</h2>
            <p>Cartz is an e-commerce platform that allows users to create and manage their online stores. We provide store hosting, order processing, and product management tools.</p>

            <h2>3. User Accounts</h2>
            <p>You are responsible for maintaining the confidentiality of your account information and password. You agree to accept responsibility for all activities that occur under your account.</p>

            <h2>4. Store Content</h2>
            <p>You are responsible for all content posted in your store including products, descriptions, images, and prices. Content must be legal and not infringe on others' rights.</p>

            <h2>5. Payments and Fees</h2>
            <p>Fees may apply to some of our services. You will be notified of any fees before they are charged. Payments between stores and their customers are handled directly and Cartz bears no responsibility for them.</p>

            <h2>6. Termination</h2>
            <p>We reserve the right to suspend or terminate your account if you violate these terms or for any other reason at our discretion.</p>

            <h2>7. Limitation of Liability</h2>
            <p>The Service is provided "as is" without any express or implied warranties. Cartz shall not be liable for any direct or indirect damages resulting from the use of the Service.</p>

            <h2>8. Modifications</h2>
            <p>We reserve the right to modify these terms at any time. You will be notified of any material changes.</p>

            <h2>9. Contact</h2>
            <p>To contact us regarding these terms, please email us at support@cartz.cc</p>
          </>
        )}
      </div>
    </div>
  );
}
